import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { applyTheme, persistTheme, readTheme, THEMES } from 'src/utils/theme';

const ThemeToggleButton = styled.button`
    display: flex;
    align-items: center;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    white-space: nowrap;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    color: var(--poki-blue);

    &:hover {
        color: var(--poki-blue);
        text-decoration: underline;
    }
`;

export default function ThemeToggle({ className }) {
    const [theme, setTheme] = useState(readTheme);

    useEffect(() => {
        applyTheme(theme);
        persistTheme(theme);
    }, [theme]);

    const toggle = () => setTheme((current) => (current === THEMES.DARK ? THEMES.LIGHT : THEMES.DARK));

    return (
        <ThemeToggleButton className={className} type="button" onClick={toggle}>
            {theme === THEMES.DARK ? 'Light mode' : 'Dark mode'}
        </ThemeToggleButton>
    );
}

ThemeToggle.propTypes = {
    className: PropTypes.string,
};

ThemeToggle.defaultProps = {
    className: '',
};
